// removed by extract-text-webpack-plugin
module.exports = {"gwCoverages__coverage":"CoveragesList-hashed__gwCoverages__coverage__3zDTZ","gwCoverages__coverage_first":"CoveragesList-hashed__gwCoverages__coverage_first__3ap2G","gwCoverages__coverageHeading":"CoveragesList-hashed__gwCoverages__coverageHeading__3K9ys"};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/coveragesList/CoveragesList-hashed.scss
// module id = 657
// module chunks = 0